import { Header, Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { CycleContext } from '@/contexts';
import type { CycleType } from '@/types';
import Relances from './Relances';
import SelectionCyclesImpayes from './SelectionCyclesImpayes';
import TransfertImpayes from './TransfertImpayes';

const Impayes = () => {
  const [cycles, setCycles] = React.useState<CycleType[]>(null);
  const [step, setStep] = React.useState<'selection' | 'transfert' | 'relances'>('selection');
  const [relanceMode, setRelanceMode] = React.useState<'avant' | 'prolongee'>('prolongee');

  const { getCycles } = React.useContext(CycleContext);

  const handleTransfert = React.useCallback(() => {
    setStep('transfert');
  }, []);

  const handleRedirectToSelection = React.useCallback(
    (resetCycles = true) => {
      if (resetCycles) {
        setCycles(null);
      }

      setStep('selection');
      getCycles();
    },
    [getCycles],
  );

  const handleCycleUpdate = React.useCallback((updatedData: Partial<CycleType>) => {
    setCycles((prev) =>
      _.map(prev, (cycle) =>
        cycle.identifiant === updatedData.identifiant ? { ...cycle, ...updatedData } : cycle,
      ),
    );
  }, []);

  const handleRelanceAvant = React.useCallback(() => {
    setRelanceMode('avant');
    setStep('relances');
  }, []);

  const handleRelanceProlongee = React.useCallback(() => {
    setRelanceMode('prolongee');
    setStep('relances');
  }, []);

  const handleCycleSelect = React.useCallback((selectedCycles: CycleType[]) => {
    setCycles(selectedCycles);
  }, []);

  return (
    <Segment
      inverted
      secondary
      style={{
        flex: 1,
        overflow: 'auto',
        background: 'transparent',
      }}
    >
      <Segment style={{ borderRadius: 14 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Header as="h1" style={{ marginBottom: '1em' }} textAlign="center">
            <Header.Content>Relances et impayés</Header.Content>
          </Header>
          {step === 'selection' && (
            <SelectionCyclesImpayes
              onItemSelect={handleCycleSelect}
              selectedItems={cycles}
              onTransfertClick={handleTransfert}
              onRelanceAvantClick={handleRelanceAvant}
              onRelanceProlongeeClick={handleRelanceProlongee}
            />
          )}
          {step === 'transfert' && (
            <TransfertImpayes
              cycles={cycles}
              onRedirectToSelection={handleRedirectToSelection}
              onCycleUpdate={handleCycleUpdate}
            />
          )}
          {step === 'relances' && (
            <Relances
              cycles={cycles}
              relanceMode={relanceMode}
              onRedirectToSelection={handleRedirectToSelection}
            />
          )}
        </div>
      </Segment>
    </Segment>
  );
};

export default Impayes;
